import styled from '@emotion/styled'
import clsx from 'clsx'
import { useState } from 'react'

import { Space, Typography } from '../../../components/core-v2'
import IconButton from '../../../components/core-v2/molecules/iconButton'
// import { QHButton } from '../../../core/button';

type Props = {
  onConfirm: () => void
  operationTitle: string
  operationType: 'destructive' | 'non-destructive'
  userName: string
}

export const StyledUserTextInput = styled.input`
  border: Solid 1px var(--White80);
  padding: 12px;
  margin: 0;
  display: inline-block;
  text-decoration: none;
  color: var(--Graphite);
  vertical-align: middle;
  background: var(--White);
  width: calc(100% - 26px);
  color: var(--Graphite);
  &:focus-visible {
    outline: none;
  }
  &:disabled {
    background: var(--White96);
    color: var(--White40);
  }
`

export default function UserOperationWithConfirm({
  onConfirm,
  operationTitle,
  operationType,
  userName
}: Props) {
  const [canDelete, setCanDelete] = useState(false)
  const [text, setText] = useState('')

  const onChange = val => {
    setText(val)
    setCanDelete(val === userName)
  }

  const buttonTitle = `${operationTitle} user`

  return (
    <>
      <Space mb={5}>
        <Typography fontSize="13px" fontWeight="400" letterSpacing="0" variant="b3">
          Please enter the username '{userName}' and click on the button below
        </Typography>
      </Space>
      <Space mb={5}>
        <StyledUserTextInput
          className={clsx({ invalid: !canDelete })}
          type="text"
          value={text}
          onChange={e => onChange(e.target.value)}
        />
      </Space>
      <IconButton
        disabled={!canDelete}
        icon={false}
        iconPosition="left"
        operationType={operationType === 'destructive' ? 'negative' : 'progress'}
        text={buttonTitle}
        onClick={() => onConfirm()}
      />
    </>
  )
}
